import { gql } from '@apollo/client';

export const QUERY_GET_SLUG_RELEASE_PRODUCT = gql`
    query getReleaseProducts(
        $page: Int = 1
        $pageSize: Int = 10
        $brand: String
        $slug: String
        $releaseDate: SortDirection
        $fromDate: String
        $toDate: String
    ) {
        getReleaseProducts(
            page: $page
            pageSize: $pageSize
            filter: { brand: $brand, slug: $slug, releaseDate: { fromDate: $fromDate, toDate: $toDate } }
            sort: { releaseDate: $releaseDate }
        ) {
            items {
                tags
                slug
            }
            totalCount
            totalPages
            # pageInfo {
            #     page
            #     pageSize
            # }
        }
    }
`;

export const QUERY_GET_OPTHER_RELEASE = gql`
    query getReleaseProducts(
        $page: Int = 1
        $pageSize: Int = 10
        $brand: String
        $slug: String
        $releaseDate: SortDirection
        $fromDate: String
        $toDate: String
    ) {
        getReleaseProducts(
            page: $page
            pageSize: $pageSize
            filter: { brand: $brand, slug: $slug, releaseDate: { fromDate: $fromDate, toDate: $toDate } }
            sort: { releaseDate: $releaseDate }
        ) {
            items {
                id
                title
                releaseDate
                publishDate
                pageTheme
                color
                styleCode
                retail
                tags
                thumbnail {
                    root
                    thumbnail
                }
                images {
                    path
                }
                brand
                brandCode
                htmlContent
                slug
                model {
                    title
                    slug
                }
            }
            totalCount
            totalPages
            # pageInfo {
            #     page
            #     pageSize
            # }
        }
    }
`;

export const QUERY_GET_RELEASE_PRODUCT = gql`
    query getReleaseProducts(
        $page: Int = 1
        $pageSize: Int = 10
        $brand: String
        $slug: String
        $releaseDate: SortDirection
        $fromDate: String
        $toDate: String
    ) {
        getReleaseProducts(
            page: $page
            pageSize: $pageSize
            filter: { brand: $brand, slug: $slug, releaseDate: { fromDate: $fromDate, toDate: $toDate } }
            sort: { releaseDate: $releaseDate }
        ) {
            items {
                id
                title
                releaseDate
                publishDate
                pageTheme
                color
                styleCode
                retail
                tags
                thumbnail {
                    root
                    thumbnail
                }
                images {
                    path
                }
                brand
                brandCode
                htmlContent
                slug
                model {
                    title
                    slug
                }
            }
            totalCount
            totalPages
        }
    }
`;

export const QUERY_GET_BRAND_RELEASE_PRODUCT = gql`
    query getBrandReleaseProducts {
        getBrandReleaseProducts {
            items {
                brand
                brandCode
            }
        }
    }
`;
